import type { CourseQuizKind } from "./hubTypes";

// SCRUM-1532 rules shared by the hub and the "Quizzes Emmi" form.

// A `<clave>_QUIZ_VIDEO` file is the quiz of the course's video.
export const quizKindFor = (
  fileName: string | null | undefined,
): CourseQuizKind => (/_QUIZ_VIDEO/i.test(fileName ?? "") ? "video" : "auto");

export const QUIZ_BLOCKED_MESSAGE =
  "Bloqueado: el quiz ya tiene respuestas de alumnos";

export const DOUBLE_QUIZ_MESSAGE =
  "Tiene quiz suelto y video-quiz: elimina uno";
